import React, {useState, useEffect, useRef} from 'react';
import {textTruncateByLength} from 'utils/other';
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from 'reactstrap';
import DeleteSavedSearchModal from './modals/DeleteSavedSearchModal';
import AssignSavedSearchModal from './modals/AssignSavedSearchModal';
// import {usePopper} from 'react-popper';
// import useClickOutside from 'Helpers/useClickOutside';
import Tooltip from 'components/Tooltip';

const SavedSearchListItem = (props) => {
    const {
        item, auth, setActiveSavedSearch, usersList, handleAssignAlert, refreshSavedSearches,
        activeSavedSearch, setDeletedSavedSearchId, setSavedSearchPeriodFilter, resetSearchValues,
    } = props;
    const containerRef = useRef();

    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [dailyAlertModalOpen, setDailyAlertModalOpen] = useState(false);
    const [hourlyAlertModalOpen, setHourlyAlertModalOpen] = useState(false);
    const [assignedDailyUsers, setAssignedDailyUsers] = useState([]);
    const [assignedHourlyUsers, setAssignedHourlyUsers] = useState([]);
    const [deletingSavedSearch, setDeletingSavedSearch] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isActive, setIsActive] = useState(false);

    const toggleDeleteModal = () => {
        isOpen && setIsOpen(false);
        setDeleteModalOpen(prevState => !prevState);
    };

    const toggleDailyModal = () => {
        isOpen && setIsOpen(false);
        setDailyAlertModalOpen(prevState => !prevState);
    };
    const toggleHourlyModal = () => {
        isOpen && setIsOpen(false);
        setHourlyAlertModalOpen(prevState => !prevState);
    };

    useEffect(() => {
        activeSavedSearch && (activeSavedSearch.id === item.id) ? setIsActive(true) : setIsActive(false);
    }, [activeSavedSearch]);


    useEffect(() => {
        determineAssignments();
    }, [item]);


    const determineAssignments = () => { // Fill if alert is assigned to users
        let daily = [];
        let hourly = [];
        if(item.userAlerts && item.userAlerts.length > 0) {
            let dailyUserAssignments = item.userAlerts.forEach(user => {
                user.dailyAlert && daily.push(user);
            });
            let hourlyUserAssignments = item.userAlerts.forEach(user => {
                user.hourlyAlert && hourly.push(user);
            });
            setAssignedDailyUsers(daily);
            setAssignedHourlyUsers(hourly);
        } else {
            setAssignedDailyUsers(daily);
            setAssignedHourlyUsers(hourly);
        }
    };


    const toggleOpen = () => {
        setIsOpen((prevState) => !prevState);
    };

    const handleSavedSearchSelect = () => {
        setSavedSearchPeriodFilter(30);
        setActiveSavedSearch(item);
    };

    return (
        <div className={`ss-list-item ${isActive ? 'ss-list-item--active' : ''}`}
             onClick={handleSavedSearchSelect}
        >
            {deleteModalOpen && (
                <DeleteSavedSearchModal
                    isOpen={deleteModalOpen}
                    toggle={toggleDeleteModal}
                    savedSearch={item}
                    deletingSavedSearch={deletingSavedSearch}
                    setDeletingSavedSearch={setDeletingSavedSearch}
                    refreshSavedSearches={refreshSavedSearches}
                    setDeletedSavedSearchId={setDeletedSavedSearchId}
                    resetSearchValues={resetSearchValues}
                />
            )}
            {dailyAlertModalOpen && (
                <AssignSavedSearchModal
                    isOpen={dailyAlertModalOpen}
                    toggle={toggleDailyModal}
                    users={usersList}
                    savedSearch={item}
                    selectedList={assignedDailyUsers}
                    handleAssignAlert={handleAssignAlert}
                    alertType="daily"
                />
            )}
            {hourlyAlertModalOpen && (
                <AssignSavedSearchModal
                    isOpen={hourlyAlertModalOpen}
                    toggle={toggleHourlyModal}
                    users={usersList}
                    savedSearch={item}
                    selectedList={assignedHourlyUsers}
                    handleAssignAlert={handleAssignAlert}
                    alertType="hourly"
                />
            )}
            <div className="ss-list-item__inner">
                <div className="ss-list-item__icon">
                    <i className="fa fa-search"
                    />
                </div>
                <div>
                    {textTruncateByLength(item.sourceName, 30)}
                </div>
            </div>
            {isActive && (
                <div>
                    <Dropdown direction="down" isOpen={isOpen} toggle={toggleOpen}>
                        <DropdownToggle className="company-actions-dropdown-dots" data-tip="Actions">
                            <Tooltip placement="bottom" wide tooltip={`Actions`} isVisible={isOpen ? false : undefined}>
                                <i style={{margin: '0'}} className="fas fa-ellipsis-v"/>
                            </Tooltip>
                        </DropdownToggle>
                        <DropdownMenu className="company-actions-dropdown-menu">
                            <DropdownItem onClick={toggleHourlyModal}>Assign Hourly Alert</DropdownItem>
                            <DropdownItem onClick={toggleDailyModal}>Assign Daily Alert</DropdownItem>
                            <DropdownItem onClick={toggleDeleteModal}>Delete</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>
            )}
        </div>
    );
};

export default SavedSearchListItem;
